import $ from 'jquery';

/**
 * Topbar
 */
export default class Topbar {

	constructor() {
		this.$body = $('body');
		this.$window = $(window);
	}

	/**
	 * Initializes the menu
	 */
	initMenu() {
		if ($('.topnav-menu').length > 0) {
			$('.topnav-menu li a').each(function() {

				const pageUrl = window.location.href.split(/[#?]/)[0];
				// @ts-ignore
				if (this.href === pageUrl) {
					$(this).addClass('active');
					$(this).parent().parent().addClass('active'); // add active to li of the current link
					$(this).parent().parent().parent().parent().addClass('active');
					$(this).parent().parent().parent().parent().parent().parent().addClass('active');
				}
			});

			// Topbar - main menu
			$('.navbar-toggle').on('click', function() {
				$(this).toggleClass('open');
				$('#navigation').slideToggle(400);
			});
		}
	}

	initSearch() {

		// Search Toggle
		const navDropdowns = $('.navbar-custom .dropdown:not(.app-search)');

		// hide on other click
		$(document).on('click', (e) => {
			// @ts-ignore
			if (e.target.id === 'top-search' || $(e.target).closest('#search-dropdown')) {
				$('#search-dropdown').addClass('d-block');
			}
			else {
				$('#search-dropdown').removeClass('d-block');
			}
			return true;
		});

		// Search Toggle
		$('#top-search').on('focus', (e) => {
			e.preventDefault();
			navDropdowns.children('.dropdown-menu.show').removeClass('show');
			$('#search-dropdown').addClass('d-block');
			return false;
		});

		// hide search on opening other dropdown
		navDropdowns.on('show.bs.dropdown', () => {
			$('#search-dropdown').removeClass('d-block');
		});
	}

	/**
	 * Initializes the menu
	 */
	init() {
		this.initMenu();
		this.initSearch();
	}
}